import React from 'react'
import { Alert, Button, Container } from 'react-bootstrap'
import Proptypes from 'prop-types'

const ErrorMessage = ({ message, onExit, onRetry }) => {
  return (
    <Container className='pt-5'>
      <Alert variant='danger'>
        <Alert.Heading>Error</Alert.Heading>
        <p>{message}</p>
        <hr />
        <div className='d-flex justify-content-end'>
          <Button 
            variant='outline-danger' 
            className='mr-2' 
            onClick={() => onExit()}
          >
            Exit
          </Button>
          <Button
            variant='outline-danger'
            onClick={() => onRetry()}
          >
            Retry
          </Button>
        </div>
      </Alert>
    </Container>
  )
}

ErrorMessage.propTypes = {
  message: Proptypes.string.isRequired,
  onExit: Proptypes.func.isRequired,
  onRetry: Proptypes.func.isRequired
}

export default ErrorMessage